<!--尖峰平谷 energy-->
<template>
  <div class="evergyBody">
    <!--日期弹窗-->
    <datePicker :endCanSelect="endCanSelect" ref="datepicker" :initDate='bgDate' @selectDate="bgDate = $event"
      type="day"></datePicker>
    <datePicker :endCanSelect="endCanSelect" ref="datepicker2" :initDate='endDate' @selectDate="endDate = $event"
      type="day"></datePicker>
    <!--左边-->
    <elCheckBoxTree slot="tree" :dataList='$store.unitStore.state.listTree' @checkItem="nowVirtualDevice = $event">
    </elCheckBoxTree>
    <!--右边-->
    <div class="monreportRigth" slot="body">
      <div class="buttonLine">
        <!--日期-->
        <span>日期:</span>
        <iconButton icoName="wedoButton/date.png" :buttonText="getDateText(bgDate)" @buttonClick="showpicker(1)">
        </iconButton>
        <span> - </span>
        <iconButton icoName="wedoButton/date.png" :buttonText="getDateText(endDate)" @buttonClick="showpicker(2)">
        </iconButton>
        <iconButton icoName="wedoButton/search.png" buttonText="查询" @buttonClick="search"></iconButton>
        <iconButton @buttonClick='exportReport' buttonText='导出' icoName="wedoButton/download.png"></iconButton>
      </div>
      <!--表格显示数据-->
      <div class="echart">
        <div class="leftEchart">
          <p class="chartTitle">占比分析</p>
          <vchart ref='vchartPie'></vchart>
        </div>
        <div class="rightEchart">
          <p class="chartTitle">累计趋势&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span>{{nowItem.name}}</span></p>
          <vchart ref='vchartBar'></vchart>
        </div>
      </div>
      <div class="infolist">
        <p class="chartTitle">汇总表</p>
        <infoList class="panel_body_long" :columns='columns' :dataList="getInfoList"
          :pageLen='allNowData.length < 5?5:allNowData.length' :totalSize="allNowData.length" :showIndex="false"
          :fillAll="true"></infoList>
      </div>
    </div>
  </div>
</template>
<script type="text/javascript">
  import treeBody from '@/components/module/slotModule/treeBody.vue'
  import infoList from '@/components/module/universal/infoList.vue'
  import datePicker from '@/components/module/universal/datePicker.vue'
  import iconButton from '@/components/module/universal/iconButton.vue'
  import dateButton from '@/components/module/universal/dateButton.vue'
  import vchart from '@/components/module/chart/vchart.vue'
  import elRadioTree from '@/components/module/tree/elRadioTree.vue'
  import elCheckBoxTree from "@/components/module/tree/elCheckBoxTree"
  export default {
    components: {
      treeBody,
      infoList,
      datePicker,
      iconButton,
      dateButton,
      vchart,
      elRadioTree,
      elCheckBoxTree
    },
    props: [],
    data () {
      return {
        getInfoList: [{"device": "设备电气","name": null,"power": "0.00","money": "0.00"},{"device": "设备电气","name": null,"power": "0.00","money": "0.00"},{"device": "设备电气","name": null,"power": "0.00","money": "0.00"},{"device": "设备电气","name": null,"power": "0.00","money": "0.00"},{"device": "设备电气","name": "总电量","power": "0.00","money": "0.00"},{"device": "设备电气","name": "未统计","power": "0.00","money": "0.00 - 0.00"},{"device": "总","name": null,"power": "0.00","money": "0.00"},{"device": "总","name": null,"power": "0.00","money": "0.00"},{"device": "总","name": null,"power": "0.00","money": "0.00"},{"device": "总","name": null,"power": "0.00","money": "0.00"},{"device": "总","name": "总电量","power": "0.00","money": "0.00"},{"device": "总","name": "未统计","power": "0.00","money": "0.00 - 0.00"}],
        virtualDeviceList: this.$store.unitStore.state.listTree,
        nowVirtualDevice: undefined,
        nowData: [],
        allNowData: [],//所有数据
        nowInfoList: [],
        nowItem: {
          name: ''
        }, //当前选中设备列表
        historyData: {}, //查询出来的历史数据,页码对应内容
        bgDate: new Date(new Date().getTime()-60*60*24*1000),
        endDate: new Date(new Date().getTime()-60*60*24*1000),
        endCanSelect: new Date(new Date().getTime()-60*60*24*1000),
        columns: [
          {
            name: "设备",
            key: "device"
          },
          {
            name: "名称",
            key: "name"
          },
          {
            name: "用电量(kWh)",
            key: "power"
          },{
            name: "电费(元)",
            key: "money"
          }
        ],
        optionsPie: {
          //color: ['#00BFEF', '#ff9a16', '#ff6c4e'],
          tooltip: {
            trigger: 'item',
            formatter: "{a}</br>{b} : {c} ({d}%)"
          },
          legend: {
            orient: 'vertical',
            left: 'left',
          },
          toolbox: {
            feature: {
              saveAsImage: {
              }
            }
          },
          series: [{"name": "用电量(kWh)","type": "pie","radius": [0,"40%"],"color": ["#00BFEF","#ff9a16","#ff6c4e","#5470c6"],"data": [{"name": 'E',"value": "0.00","label": {"show": false},"labelLine": {"show": false,"length": 0,"length2": 0}},{"name": 'F',"value": "0.00","label": {"show": false},"labelLine": {"show": false,"length": 0,"length2": 0}},{"name": 'G',"value": "0.00","label": {"show": false},"labelLine": {"show": false,"length": 0,"length2": 0}},{"name": 'H',"value": "0.00","label": {"show": false},"labelLine": {"show": false,"length": 0,"length2": 0}}]},{"name": "电费(元)","type": "pie","radius": ["50%","75%"],"color": ["#0c43f7","#E77420","#E0402B","#91cc75"],"data": [{"name": "A电费","value": "0.00","label": {"show": false},"labelLine": {"show": false,"length": 0,"length2": 0}},{"name": "B电费","value": "0.00","label": {"show": false},"labelLine": {"show": false,"length": 0,"length2": 0}},{"name": "C电费","value": "0.00","label": {"show": false},"labelLine": {"show": false,"length": 0,"length2": 0}},{"name": "D电费","value": "0.00","label": {"show": false},"labelLine": {"show": false,"length": 0,"length2": 0}}]}]
        },
        optionsBar: {
          tooltip: {
            trigger: 'axis',
            axisPointer: { // 坐标轴指示器，坐标轴触发有效
              type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
            }
          },
          toolbox: {
            feature: {
              saveAsImage: {
              }
            }
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          xAxis: {
            type: 'category',
            data: [1,2,3,4],
            axisTick: {
              alignWithLabel: true
            }
          },
          yAxis: {
            type: 'value'
          },
          series: [{"name": "电费(元)","type": "bar","barWidth": "20%","itemStyle": {"normal": {}},"data": [{"name": "A","value": "1.00"},{"name": "B","value": "4.00"},{"name": "C","value": "2.00"},{"name": "D","value": "5.00"}]},{"name": "用电量(kWh)","type": "bar","barWidth": "20%","itemStyle": {"normal": {}},"data": [{"name": "E","value": "6.00"},{"name": "F","value": "3.00"},{"name": "G","value": "2.00"},{"name": "H","value": "4.00"}]}]
        }
      }
    },

    mounted () {

      this.$refs.vchartPie.setData(this.optionsPie,true)
      this.$refs.vchartBar.setData(this.optionsBar,true)

    },

    computed: {
      nowUnit () {
        return this.$store.unitStore.getters.getNowUnit
      },
      variableTree () {
        return no => {
          return this.$store.variableStore.getters.getVariableTree(no)
        }
      },
      getPie () {
      },
      getBar () {
        var nameList=[]
        var powerList=[]
        var moneyList=[]
        for(var i=0,len=this.nowData.length;i<len;i++) {
          var item=this.nowData[i]
          if(item.type=="all"||item.type=="uncount") {
            continue
          }
          nameList.push(item.name)
          var pwValue=item.value
          var moneyValue=cutDigital(0)
          if(isNaN(parseFloat((pwValue)))||isnull(parseFloat((pwValue)))) {
            pwValue=undefined
          }

          if(!isempty(pwValue)) {
            moneyValue=cutDigital(item.value*item.price)
          }
          powerList.push({
            name: item.name,
            value: pwValue,
          })
          moneyList.push({
            name: item.name,
            value: moneyValue //cutDigital(item.value * item.price)
          })
        }
        return {
          xAxis: {
            data: nameList
          },
          series: [{
            name: '电费(元)',
            type: 'bar',
            barWidth: '20%',
            itemStyle: {
              normal: {
                //每个柱子的颜色即为colorList数组里的每一项，如果柱子数目多于colorList的长度，则柱子颜色循环使用该数组#00BFEF
                color: function(params) {
                  var colorList=['#00BFEF','#FF9A16','#FF6C4E','#5470c6'];
                  return colorList[params.dataIndex];
                }
              },
            },
            data: moneyList //this.nowData.price * this.nowData.price 
          },{
            name: '用电量(kWh)',
            type: 'bar',
            barWidth: '20%',
            itemStyle: {
              normal: {
                //每个柱子的颜色即为colorList数组里的每一项，如果柱子数目多于colorList的长度，则柱子颜色循环使用该数组
                color: function(params) {
                  var colorList=['#0c43f7','#E77420','#E0402B','#91cc75'];
                  return colorList[params.dataIndex];
                }
              },
            },
            data: powerList
          }]

        }

      },
      getDateText () {
        return dateBean => {
          return dateBean.formatByDate('-')
        }
      }
    },
    watch: {
      nowVirtualDevice (nv,ov) {
        this.search();
      },
      getBar (nv,ov) {
        this.$refs.vchartBar.setData(nv)
      },

      nowItem (nv,ov) {
        this.search()
      },
      bgDate (nv,ov) {
        this.$refs.datepicker.hide()
        this.search()
      },
      endDate (nv,ov) {
        this.$refs.datepicker2.hide()
        this.search()
      },
    },
    methods: {
      exportReport () {
        //导出数据
        let start=new Date(this.bgDate.formatByDate()+" 00:00:00").getTime()
        let end=new Date(new Date(this.endDate).format('yyyy-MM-dd')+' 23:59:59').getTime()
        let device={}
        //device[this.nowItem.no] = this.nowItem.name
        this.nowVirtualDevice.forEach(item => {
          device[item.no]=item.label;
        })
        this.$api.powerApi.exportDevicePG(start,end,JSON.stringify(device),respon => {
          saveAs(DWSystemSetting.downloadUrl+'/'+respon,new Date(start).format('yyyy-MM-dd')+'到'+new Date(end).format('yyyy-MM-dd')+'的尖峰平谷表'+".xls")
        })
      },
      showpicker (no) {
        if(no==1) {
          this.$refs.datepicker.show()
        } else {
          this.$refs.datepicker2.show()
        }
      },
      checkItem (item) {
        this.nowDevice=item
        this.search()
      },
      search () {
        // if(this.nowItem == undefined) {
        // 	this.$dialogMethod.showMessage('请先选中一个组或者设备！')
        // 	return
        // }
        //先查询设备信息  再查数据
        if(isempty(this.nowVirtualDevice)) {
          return;
        }
        var deviceNoList=[]
        for(var i=0;i<this.nowVirtualDevice.length;i++) {
          if(!isempty(this.nowVirtualDevice[i].children)) {
            continue
          } else {
            deviceNoList.push(this.nowVirtualDevice[i].no)
          }
        }

        this.$dialogMethod.showLoading('正在查询数据...')
        var start=new Date(this.bgDate.formatByDate()+" 00:00:00").getTime()
        /*var end = this.endDate.getTime() + 24 * 60 * 60 * 1000*/
        let end=new Date(new Date(this.endDate).format('yyyy-MM-dd')+' 23:59:59').getTime()
        var ignordList=['all','uncount']
        if(this.nowItem.type=='group') {
          //是组的
          //this.$api.powerApi.getClassPG(this.nowItem.no, start, end,
          this.$api.powerApi.getClassPG(deviceNoList.join(','),start,end,
            respon => {
              //结果需要处理一下，是多个设备的，要总加
              var deviceList=Object.values(respon)
              var idToBean={}
              for(var i=0,len=deviceList.length;i<len;i++) {
                var valueList=deviceList[i]
                //每个设备单独计算
                for(var i2=0,len2=valueList.length;i2<len2;i2++) {
                  var item=valueList[i2]
                  var temp=idToBean[item.id]
                  if(temp==undefined) {
                    temp=item
                    temp.money=ignordList.includes(item.type)? '-':cutDigital(item.price*item.value)
                    idToBean[item.id]=temp
                    continue
                  }
                  temp.money+=ignordList.includes(item.type)? '-':cutDigital(item.price*item.value)
                  temp.power+=item.value
                }
              }
              this.nowData=Object.values(idToBean).sort((a,b) => {
                return a.sort-b.sort
              })
              this.$dialogMethod.closeLoading();
            },respon => {
              this.$dialogMethod.closeLoading();
              this.$dialogMethod.showMessage(respon)
            })
        } else {
          //是设备的
          //var deviceNo = this.nowItem.no
          //this.$api.powerApi.getDevicePG(deviceNo, start, end,
          this.$api.powerApi.getDevicePG(deviceNoList.join(','),start,end,
            respon => {
              // if(respon[deviceNo] == undefined) {
              // 	this.$dialogMethod.showMessage("数据缺失!")
              // 	this.$dialogMethod.closeLoading()
              // 	return
              // }
              // respon[deviceNo].forEach(item => {
              // 	item.money = ignordList.includes(item.type) ? '-' : cutDigital(item.price * item.value)
              // })
              // this.nowData = respon[deviceNo]
              let sumArr=[];//计算多选
              let tableData=[];//表格数据
              if(isempty(respon)) {
                this.$dialogMethod.showMessage("数据缺失!")
              } else {
                for(const key in respon) {
                  let dataArr=respon[key];
                  if(!isempty(dataArr)) {

                    if(!isempty(sumArr)) {
                      //如果不为空则循环加值
                      for(let i=0;i<dataArr.length;i++) {
                        if(dataArr[i].name==sumArr[i].name) {
                          sumArr[i].value=Number(sumArr[i].value)+Number(dataArr[i].value);
                          sumArr[i].money=Number(isempty(sumArr[i].money)? 0:sumArr[i].money)+Number(cutDigital(dataArr[i].price*dataArr[i].value));
                        }
                      }
                    } else {
                      //如果sumArr为空 先把dataArr放进去  深拷贝
                      sumArr=JSON.parse(JSON.stringify(dataArr))
                    }
                    console.log(sumArr,8787878787)
                    //表格数据
                    this.nowVirtualDevice.forEach(item => {
                      if(item.no==key) {
                        dataArr.forEach(i => {
                          i.device=item.label;
                          tableData.push(i);
                        })
                        return;
                      }
                    })
                  }
                }
              }
              sumArr.forEach(item => {
                item.device="总";
              })
              this.nowData=sumArr;
              this.allNowData=tableData.concat(sumArr);//合并
              this.$dialogMethod.closeLoading()
            },respon => {
              this.$dialogMethod.closeLoading()
            })
        }

      },
    }
  }
</script>

<style scoped>
  .echart {
    width: 100%;
    height: calc(100% - 3.6rem);
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-top: .1rem;
    background: white;
    margin-top: 10px;
  }

  .echart>>>.default-chart {
    height: calc(100% - .5rem);
    background: none;
    width: 100%;
    background-size: 100% 100%;
  }

  .leftEchart {
    width: 33%;
    margin-left: .1rem;
    height: 100%;
    background-size: 100% 100%;
  }

  .chartTitle {
    background-size: 100% 100%;
    height: 37px;
    line-height: 37px;
    font-size: 16px;
    padding-left: .1rem;
  }

  .rightEchart {
    width: calc(67% - .3rem);
    margin-left: .1rem;
    margin-right: .1rem;
    height: 100%;
  }

  .infolist {
    width: 100%;
    height: 2.8rem;
    margin-top: .1rem;
    background: white;
  }

  .infolist>>>.infoListBody {
    width: auto;
    height: calc(100% - 37px);
    padding: .01rem;
  }

  .monreportRigth {
    width: 100%;
    height: 100%;
    overflow: hidden;
  }

  .evergyBody {
    width: 100%;
    display: flex !important;
    align-items: center;
    justify-content: space-between;
  }
</style>